module.exports = {"title":"Art","layout":"page","path":"/art","body":"<h3><a href=\"http://imgur.com/a/yj0qI\">portraits</a></h3>\n<a href=\"http://imgur.com/a/yj0qI\">\n\t<img src=\"http://i.imgur.com/MhLQjhx.png\" width=\"300\">\n</a>\n<h3><a href=\"http://imgur.com/a/6YJ9u\">pixel art</a></h3>\n<a href=\"http://imgur.com/a/6YJ9u\">\n\t<img src=\"http://i.imgur.com/rsWXXJt.png\" width=\"300\">\n</a>\n<h3><a href=\"http://imgur.com/a/h8S9i\">misc</a></h3>\n<a href=\"http://imgur.com/a/h8S9i\">\n\t<img src=\"http://i.imgur.com/9dTV8JM.png\" width=\"300\">\n</a>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/art/index.md
// module id = 512
// module chunks = 0